<template>
  <div>
    <section class="footer-color footer-padding" >
      <div class="container ">
        <div class="row   pt-3 justify-content-center">
          <div class="col-12 col-md-6">
            <div class="row">
              <div class=" col-auto col-md-3  text-left left-data">
            <h3 >公司概況</h3>
            <h5 ><router-link :to="{name:'aboutus'}" >關於久億光電</router-link></h5>
          </div>
          <!-- <div class="w-100 d-sm-none"></div> -->
          <div class="col-auto col-md-3  text-left left-data">
            <h3 >客戶服務</h3>
            <h5 ><router-link :to="{name:'privacy'}" >隱私權政策</router-link></h5>
            <h5 ><router-link :to="{name:'service'}" >服務條款</router-link></h5>
          </div>
          <div class=" col-6   text-left left-data" >
            
            <div class="row" v-if="tags.length >= 1">
              <div class="col-12"><h3>服務項目</h3></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=2&page=1'}">{{tags[0]['name']}}</router-link></h5></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=3&page=1'}">{{tags[1]['name']}}</router-link></h5></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=4&page=1'}">{{tags[2]['name']}}</router-link></h5></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=5&page=1'}">{{tags[3]['name']}}</router-link></h5></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=6&page=1'}">{{tags[4]['name']}}</router-link></h5></div>
              <div class="col-6 col-md-5 col-xl-5"><h5 ><router-link :to="{ path:'/charttest?tag=39&page=1'}">{{tags[5]['name']}}</router-link></h5></div>
            </div>
           
          </div>
           <!-- <div class="w-100 d-sm-none"></div> -->
          <!-- <div class=" col-6 col-md-3 col-lg-auto  text-left left-data">
            <h3 >工程實績</h3>
            
            
            
           
          </div> -->
           <!-- <div class="w-100 d-sm-none"></div> -->
          
<!-- left-end  -->
            </div>
          </div>
          <div class="col-12  col-xl-auto text-xl-center text-xs-right mt-3 mt-xl-0">
            <a href="https://line.me/ti/p/%40eul9081i" ><img src="/static/line.png" style="max-width:183px" alt="" ></a>
            <a href="https://line.me/ti/p/%40eul9081i" class="text-cenetr d-block" style="font-size: 20px">點我加Line</a>
          </div>
          <div class="col-12 col-md-6 col-xl-auto text-right  right-data mt-4 mt-xl-0 " style="letter-spacing:5px">
            <img src="/static/icon/icon-01@4x2.jpg" style="" class="msg-png">
            
            
            <!-- <h1 style="color: black">久億光電科技有限公司</h1>
            <h1  class="text-danger">台中總公司-04-23899999</h1>
            <h5 >F:04-23502499</h5>
            <h5 >Email:kuan0124@seed.net.tw</h5>
            <h5 >台中市南屯區黎明路一段820號</h5>
            <h1  class="text-danger">桃園分公司-03-2170787</h1>
            <h5 >桃園市文中路15號</h5> -->
          </div>
        </div>
      </div>
    
    </section>
   <div class="botgray" style="padding-top:22.5px;padding-bottom:22.5px">
      <div class="container text-left">
        <p style="font-size:14px" class="my-0 d-inline-block">Copyright © 2018 久億光電科技有限公司 All rights reserved.</p>
         <p style="font-size:14px" class="my-0 ml-xl-2 ml-0 d-inline-block">Design by <a style="color:black"  href="#">無極限</a></p>
      </div>
    </div>


  </div>
</template>
<script>
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
Vue.use(VueAxios, axios)
export default {
  data(){
    return{
        tags:[]
    }
    
  },
  methods:{
      getAllTag:function() {
      let vm = this;
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/categories" 
      })
        .then(function(response) {
          response.data.data.forEach(element => {
            
            vm.tags.push(element);
            // console.log(vm.tags)
          });
          
        })
    }
  },
  created(){
  this.getAllTag();
  }
}
</script>

<style lang="sass" scoped>
$grid-gutter-width: 20px
@import "~bootstrap/scss/bootstrap"

.botgray
  background-color: rgb(125, 125, 125)
  color: rgb(50, 50, 50)

.footer-color
  background-color: rgb(205, 205, 205)
  color: rgb(125, 125, 125)
.left-data
  color: rgb(50, 50, 50)
  a
    color: rgb(50, 50, 50)
  h3
    @include media-breakpoint-up(xs) 
      font-weight: bold
      font-size: 15px
      margin-bottom: 35px
    @include media-breakpoint-up(xl) 
      font-weight: bold
      margin-bottom: 21px
      font-size: 20px
  h5
    @include media-breakpoint-up(xs) 
      font-size: 12px
      margin-bottom: 20px
    @include media-breakpoint-up(xl) 
      margin-bottom: 15px
      font-size: 17px

.right-data
  h1
    @include media-breakpoint-up(xs)
      font-size: 18px
      font-weight: bold
  h5
    @include media-breakpoint-up(xs)
      font-size: 12px
      color: black

.footer-padding
  @include media-breakpoint-up(xl)
    padding-top: 60px
    padding-bottom: 51px
  @include media-breakpoint-up(xs)  
    padding-top: 30px
    padding-bottom: 40px
.padding-xs-xl
  @include media-breakpoint-up(xl)  
    padding-left: 15px
    padding-right: 15px
  @include media-breakpoint-up(xs)
    padding-left: 10px
    padding-right: 10px  
.msg-png
  @include media-breakpoint-up(xs)  
    width: 100%
    height: 100%
  @include media-breakpoint-up(xl)  
    width: 330px
    height: 100%
</style>





// WEBPACK FOOTER //
// src/components/FooterView.vue